<template>

  <b-form-group
    :label="label + (isRequired?' *': '')"
    label-for="phoneNumber-input"
    class="bold-label"
    :invalid-feedback="phoneNumber.invalidFeedback"
    :state="phoneNumber.state">
    <vue-phone-number-input
      id="phoneNumber-input"
      v-model="phoneNumber.value"
      :state="phoneNumber.state"
      :error="phoneNumber.error"
      :translations="translations"
      :default-country-code="phoneNumber.countryCode"
      :required="isRequired"
      @update="checkPhoneNumber">
    </vue-phone-number-input>
  </b-form-group>

</template>

<script>

export default {

  name: 'PhoneNumberField',
  components: {},

  props: {
    isRequired: {
      type: Boolean,
      default: true
    },
    phoneNumber: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: function () {
        return this.$t('phoneNumber.phoneNumberLabel')
      }
    }
  },

  computed: {

    translations() {
      return {
        countrySelectorLabel: this.$i18n.t('phoneNumber.countrySelectorLabel'),
        countrySelectorError: this.$i18n.t('phoneNumber.countrySelectorError'),
        phoneNumberLabel: this.$i18n.t('phoneNumber.phoneNumberLabel'),
        example: this.$i18n.t('phoneNumber.example')
      }
    }

  },

  methods: {

    checkPhoneNumber(value) {
      this.phoneNumber.formattedNumber = value.formattedNumber
      this.phoneNumber.countryCode = value.countryCode
      if (value.phoneNumber && !value.isValid) {
        this.phoneNumber.state = false
        this.phoneNumber.invalidFeedback = this.$i18n.t('phone.number.invalid.error')
      }
      else {
        this.phoneNumber.state = true
        this.phoneNumber.invalidFeedback = null
      }
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/PhoneNumberField.vue